import { PricingsListModule } from '@/components/modules/PricingsList/PricingsList';
import { APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

import { DYNAMIC_PAGE_PATHS } from '../../shared/pathRoutes';

export const PAGE_PRICINGS_LIST: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.PRICINGS_LIST,
  schemesByRoles: [
    {
      roles: [APP_ROLES.ADMIN, APP_ROLES.SUPER_ADMIN, APP_ROLES.MERCHANT, APP_ROLES.CHANNEL, APP_ROLES.AGENT],
      titleTextId: 'PRICINGS',
      widgets: [],
    },
  ],
  sections: [
    {
      textId: '',
      module: (
        <PricingsListModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.MERCHANT,
              APP_USER_TYPES.MERCHANT_GROUP,
              APP_USER_TYPES.CHANNEL,
              APP_USER_TYPES.AGENT,
            ],
            edit: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN],
          }}
        />
      ),
    },
  ],
};
